<template>
  <div class="vendor-form">
    <h1
      id="head-title"
      class="page-title text-gradient text-center"
      data-aos="fade-right"
      data-aos-easing="ease-in-out-quad"
      data-aos-once="true"
      data-aos-duration="1000"
    >
      2026 Vendor Application Form
      <br />
      <span class="sub-title sub-text"
        >Saturday 1st August - Victoria Park, Leicester</span
      >
    </h1>

    <div class="form-container text-center">
      <a :href="stallsFormUrl" target="_blank" rel="noopener noreferrer">
        <b-button class="btn-carnival bg-yellow text-blue font-weight-bold">
          Open Stalls Form
        </b-button>
      </a>
      <div class="mt-4">
        <router-link
          to="/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          Read Terms & Conditions
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VendorForm',
  data() {
    return {
      stallsFormUrl: 'https://forms.gle/5C5TSbohtb25UWNTA',
    };
  },
};
</script>

<style scoped>
.page-title {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.sub-title {
  font-size: 1.25rem;
}

.form-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 1rem;
}

.vendor-form {
  padding-bottom: 7rem;
}

.sub-text {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
</style>
